module.exports = __webpack_public_path__ + "static/media/AlwynNewRounded_Medium.3d589fa7.woff";